export default {
    root: ({ props }) => ({
        class: [
            'toggleswitch-root',
            {
                'toggleswitch-root_disabled': props.disabled,
            },
        ],
    }),
    slider: ({ props }) => ({
        class: [
            'toggleswitch-slider',
            {
                'toggleswitch_active': props.modelValue == props.trueValue,
                'toggleswitch_inactive': props.invalid,
            },
        ],
    }),
    input: {
        class: ['toggleswitch-input'],
    },
};
